import React, {Component} from 'react'
import {Select} from 'antd'
import {compose} from 'recompose'

import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import withSort from '../../HOC/withSort'

const Option = Select.Option

class ValueType extends Component {
  render() {
    const {value, onChange, placeholder, data} = this.props
    return (
      <Select
        {...this.props}
        style={{minWidth: '130px'}}
        value={value}
        showSearch
        onChange={onChange}
        placeholder={placeholder || 'Select a Type'}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }>
        {data.map(c => <Option value={c.key}>{c.value}</Option>)}
      </Select>
    )
  }
}

export default compose(
  withSelectFetch({dropdown: 'employee', name: 'valueType'}),
  withSpinning,
  withSort,
)(ValueType)
